import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
   
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    
  
    if (!window.scrollTo || typeof window.scrollTo !== 'function') {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop; 